import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		justifyContent: 'center',
	},
	loadingImages: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	formControlWrap: {
		width: '100%',
		marginBottom: 72,
		...CssSelectors.allChildren(
			{
				display: 'block',
				color: charmGray,
				fontSize: 14,
				marginBottom: 12,
			},
			'label'
		),
		...CssSelectors.allDescendants(
			{
				display: 'block',
				color: charmGray,
				fontSize: 14,
				marginBottom: 12,
			},
			'.industries-header'
		),
	},
	formControlWrapSpacers: {
		marginBottom: 16,
		...CssSelectors.allChildren(
			{
				display: 'block',
				color: charmGray,
				fontSize: 14,
				marginBottom: 12,
			},
			'label'
		),
	},
	footer: {
		display: 'flex',
		paddingBottom: 34,
		...CssSelectors.allChildren({
			marginRight: 16,
		}),
	},
	generate: {},
	innerContainer: {
		width: '100%',
		maxWidth: 830,
		border: 0,
	},
	mainTitle: {
		color: brandPrimary,
		fontSize: 18,
		margin: '40px 0',
	},
	mediaModalStyle: {},
	prompt: {
		background: '#F9F9F9',
		border: '1px solid #ccc',
		height: 360,
		margin: '12px 0',
		marginBottom: 12,
		overflow: 'auto',
		width: '100%',
		...CssSelectors.allDescendants(
			{
				borderBottom: '1px solid #ccc !important',
			},
			'.tox-toolbar__primary'
		),
	},
	summary: {
		marginBottom: 12,
		height: 120,
	},
	previewSection: {
		marginTop: 72,
		marginBottom: 36,
		...CssSelectors.allDescendants(
			{
				marginBottom: 6,
				fontSize: 16,
				color: titles,
				fontWeight: 'bold',
			},
			'h3'
		),
		...CssSelectors.allDescendants(
			{
				marginTop: 0,
				marginBottom: 24,
				fontSize: 14,
				color: titles,
			},
			'p'
		),
	},
	refreshIcon: {
		marginRight: 8,
		transitions: 'transform 5000ms',
	},
	subTitle: {
		color: brandPrimary,
		fontSize: 16,
		marginBottom: 12,
		margin: 0,
	},
	tagline: {
		color: charmGray,
		fontSize: 12,
		marginTop: 0,
		marginBottom: 24,
	},
});
